import React, { FunctionComponent, useContext, useRef } from 'react';
import { ModalContext } from 'ui/molecules/modal';
import LoadingRing from 'ui/atoms/loading-ring';
import * as Styled from './styled';
import Margin from 'ui/types/margin';
import { ReactNode } from 'react';

interface ModalContentProps {
  loading?: boolean;
  className?: string;
  margin?: Margin;
  children?: ReactNode;
}

export const ModalContent: FunctionComponent<ModalContentProps> = ({
  children,
  margin,
  loading = false,
  className,
}) => {
  const { bgColor } = useContext(ModalContext);

  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.ModalContent $bgColor={bgColor} $margin={margin} className={className} ref={contentRef}>
      {loading ? (
        <Styled.ModalContentLoader>
          <LoadingRing />
        </Styled.ModalContentLoader>
      ) : (
        children
      )}
    </Styled.ModalContent>
  );
};

export default ModalContent;
